"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableContainer = exports.NoResultsContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var TableContainer = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    overflow-x: auto;\n    white-space: nowrap;\n\n    &.active {\n        padding-bottom: 80px;\n    }\n\n    .selected {\n        background-color: #ebf3ff;\n    }\n\n    .table {\n        width: calc(100% - 1px);\n\n        thead {\n            th {\n                border: none;\n                font-weight: 400;\n            }\n        }\n\n        tbody {\n            border-left: 1px solid #dee2e6;\n            border-right: 1px solid #dee2e6;\n            border-bottom: 1px solid #dee2e6;\n            font-size: 0.85rem;\n            font-weight: 300;\n\n            tr {\n                background-color: #fff;\n                height: 56px;\n\n                td {\n                    vertical-align: middle;\n\n                    img {\n                        height: 30px;\n                    }\n\n                    .badge {\n                        font-size: 90%;\n                        font-weight: 400;\n                    }\n                }\n            }\n        }\n    }\n"])));

exports.TableContainer = TableContainer;

var NoResultsContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n\n    p {\n        font-size: 1.1rem;\n    }\n"])));

exports.NoResultsContainer = NoResultsContainer;